import { BaseScreen } from "./BaseScreen";

import { BackHeader } from "./components/BackHeader";

import { ProductTitleBlock } from "../blocks/ProductTitleBlock";
import { StickerListBlock } from "../blocks/StickerListBlock";
import { TitleBlock } from "../blocks/TitleBlock";

import type { Block } from "../blocks/Block";

import type { StateStore } from "../app/state/StateStore";
import type { HeaderEvents } from "./components/HeaderEvents";
import type { SubscriptionChangeActions } from "./components/SubscriptionChangeActions";
import type { Screen } from "../app/api/ApiClient";

type SubscriptionsScreenModel =
    Extract<Screen, { type: "subscriptions" }>;

export class ChangeSubscriptionsScreen
    extends BaseScreen {

    private readonly store: StateStore;

    private readonly headerEvents: HeaderEvents;

    private readonly actions: SubscriptionChangeActions;

    private readonly screen: SubscriptionsScreenModel;

    private readonly blocks: Block[] = [];

    private root!: HTMLElement;

    constructor(
        screen: SubscriptionsScreenModel,
        store: StateStore,
        headerEvents: HeaderEvents,
        actions: SubscriptionChangeActions
    ) {

        super();

        this.screen = screen;
        this.store = store;
        this.headerEvents = headerEvents;
        this.actions = actions;

    }

    public override mount(): void {

        super.mount();

        this.root =
            this.buildRoot();

    }

    public override update(): void {

        super.update();

        for (const block of this.blocks) {
            block.unmount();
        }

        const newRoot =
            this.buildRoot();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

    // =====================================================

    private buildRoot(): HTMLElement {

        const root =
            document.createElement("div");

        root.className =
            "subscriptions-screen";

        const header =
            new BackHeader(
                this.headerEvents
            );

        header.mount();

        root.appendChild(
            header.getRoot()
        );

        root.style.paddingTop =
            "70px";

        const container =
            document.createElement("div");

        container.className =
            "subscriptions-container";

        root.appendChild(
            container
        );


        this.buildBlocks();

        for (const block of this.blocks) {

            block.mount();

            container.appendChild(
                block.getRoot()
            );

        }

        return root;

    }

    private buildBlocks(): void {

        this.blocks.length = 0;

        this.blocks.push(

            new TitleBlock(
                "Зміна підписки"
            )

        );

        this.blocks.push(

            new ProductTitleBlock(

                this.store.getState()
                    .productTitle ?? ""

            )

        );

        this.blocks.push(

            new StickerListBlock(

                this.store.getState()
                    .stickers ?? [],

                (stickerId: string) => {

                    this.actions.confirmChange(
                        stickerId
                    );

                }

            )

        );

    }

}